import { User } from '@/types/user';
import { SEARCH_HEADER_BUTTON } from '../constants/buttons';
import { Button } from './Button.types';

export const getSearchHeaderButtons = (user: User, isMobileView: boolean): Button[] => {
  if (user) {
    const isMerchant = user?.about?.isMerchant;

    if (isMerchant) {
      return [SEARCH_HEADER_BUTTON.MANAGE_COMPANY];
    }

    const items: Button[] = [];

    if (!isMobileView) {
      items.push(SEARCH_HEADER_BUTTON.MY_BOOKINGS, SEARCH_HEADER_BUTTON.FAVORITES);
    }

    items.push(SEARCH_HEADER_BUTTON.PROFILE);
    return items;
  }

  return [SEARCH_HEADER_BUTTON.CONNECT_COMPANY, SEARCH_HEADER_BUTTON.LOGIN];
};
